<template>
  <div class="main_Container">
    <section class="p-4">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <h3 class="card-header-title">أضافة فيديو</h3>
          </div>
          <div class="card-body">
            <form @submit.prevent="addNewVideo">
              <div class="card-body__form">
                <div class="row">
                  <!-- Video Title -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="videoTitle">العنوان</label>
                      <input
                        type="text"
                        id="videoTitle"
                        class="form-control"
                        placeholder="العنوان"
                        v-model="video.title"
                        required
                      />
                    </div>
                  </div>
                  <!-- Video Price -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="videoPrice">السعر</label>
                      <input
                        type="number"
                        class="form-control mt-2"
                        id="videoPrice"
                        min="0"
                        placeholder="السعر"
                        v-model="video.price"
                        required
                      />
                    </div>
                  </div>
                  <!-- Video Description -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="videoDescription">الوصف</label>
                      <textarea
                        id="videoDescription"
                        cols="30"
                        rows="10"
                        class="form-control"
                        placeholder="الوصف"
                        v-model="video.description"
                      ></textarea>
                    </div>
                  </div>
                  <!-- Video Thumbnail -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="videoThumbnail">صورة الفيديو</label>
                      <UploadImages
                        class="form-control"
                        id="videoThumbnail"
                        :max="1"
                        maxError="يمكنك رفع صورة واحدة لكل درس"
                        fileError="لا يمكن رفع ملفات غير الصور"
                        @changed="handleImages"
                      />
                    </div>
                  </div>

                  <!-- Embed Code -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="embedCode">أضافة كود الفيديو</label>
                      <textarea
                        id="embedCode"
                        cols="30"
                        rows="9"
                        class="form-control"
                        placeholder="أضافة كود"
                        v-model="video.embed"
                        required
                      ></textarea>
                    </div>
                  </div>

                  <!-- Embed Video -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="embedVideo">الفيديو</label>
                      <div class="mt-2">
                        <div
                          class="videoShow"
                          id="embedVideo"
                          v-html="video.embed"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <!-- Additional Link -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="additionalLink">الرابط الإضافي</label>
                      <textarea
                        id="additionalLink"
                        cols="30"
                        rows="5"
                        class="form-control"
                        placeholder="الرابط الإضافي"
                        v-model="video.additional_url"
                      ></textarea>
                    </div>
                  </div>
                  <!-- Video Duration -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="videoDuration">مدة الفيديو</label>
                      <input
                        type="number"
                        id="videoDuration"
                        class="form-control"
                        required
                        placeholder="مدة الفيديو بالدقائق"
                        v-model="video.duration"
                      />
                    </div>
                  </div>

                  <!-- Video From Additional Link -->
                  <!-- <div class="col-lg-6">
                  <div class="form-group">
                    <label for="videoFromAdditionalLink">
                      فيديو من الرابط الإضافي
                    </label>
                    <div class="mt-2">
                      <div
                        class="videoShow dl-neon-vid"
                        id="videoFromAdditionalLink"
                      >

                      </div>
                    </div>
                  </div>
                </div> -->
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" class="btn btn-primary">حفظ</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Upload Image Drag and Drop
import UploadImages from "vue-upload-drop-images";
// vuex
import { mapActions } from "vuex";
// Swal
import Swal from "sweetalert2";
// Firebase Upload Component
import FirebaseUploadingFileVue from "@/components/FirebaseUploadingFile.vue";
// Toast to Show Message
import { useToast, TYPE } from "vue-toastification";
const toast = useToast();

export default {
  name: "AddVideo",
  data() {
    return {
      video: {
        type: 2, // Video
        title: "",
        price: "",
        embed: "",
        thumbnail_url: "",
        description: "",
        additional_url: "",
        duration: 0,
      },
      file: null,
    };
  },
  components: {
    UploadImages,
  },
  props: ["index"],
  methods: {
    ...mapActions("lessonsModule", ["addVideo"]),

    // Add Video
    async addNewVideo() {
      if (this.file !== null) {
        const content = {
          // Your component or JSX template
          component: FirebaseUploadingFileVue,
          // Props are just regular props, but these won't be reactive
          props: {
            title: "يتم رفع صورة الفيديو الان",
            file: this.file,
            collection: "IMAGES",
            contentType: "image/jpeg",

            onFinished: (url) => {
              console.log(url);
              this.video.thumbnail_url = url ?? "";
              toast.dismiss(toastId);
              this.addVideo(this.video);
              this.clearAndShowSuccess();
              this.$router.go(-1);
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      } else {
        this.addVideo(this.video);
        this.clearAndShowSuccess();
        this.$router.go(-1);
      }
    },

    handleImages(files) {
      this.file = files[0];
    },
    //---------------------//
    // clear Data when close modal
    clearData() {
      this.file = null;
      document.getElementById("videoThumbnail").value = "";
      let clearButton = document.querySelector(".clearButton");
      clearButton.click();
      this.video = {
        title: "",
        price: "",
        embed: "",
        thumbnail_url: "",
        description: "",
        additional_url: "",
        duration: 0,
      };
    },
    // On Upload Image
    seccussAddQuestion() {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "تم إضافة الفيديو بنجاح",
      });
    },
    //
    clearAndShowSuccess() {
      this.seccussAddQuestion();
      this.clearData();
    },
  },
  created() {
    console.log();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.form-control {
  max-width: 100% !important;
}
.videoShow {
  max-width: 100%;
  max-height: 200px;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 200px !important;
  }
}
</style>